(function() {
  var nTimer = setInterval(function() {
	if ( window.jQuery ) {
	  initJqueryFuncs();
	  clearInterval(nTimer);
	}
  }, 1000);
})();

function initJqueryFuncs(){
	$(document).ready(function() {
		showReturnBtn();
	});
}

function showReturnBtn(){
	if( $(".return-btn").length <= 0 ){ return; }
	$(".return-btn").append('<p><button class="button button--primary return-code-trigger">Start your return</button></p>');
    returnBtnClick();
}

function returnBtnClick(){
    $(document).on('click', '.return-code-trigger', function(e){
        e.preventDefault();
    	var lform = $(".return-form-1").html();
    	$("#myModal .modal-body").html(lform);
        $("#myModal .modal-title").html("<span class='green'>Return an order</span>");
        $(".modal-body .ReturnForm1 .alert").html('');
        $(".modal-body .ReturnForm1 .alert").hide();
        $(".modal-body .ReturnForm1 .alert").removeClass('alert-success');
        $(".modal-body .ReturnForm1 .alert").removeClass('alert-danger');
        $("#myModal").modal('show');
        
        $(".ReturnForm1").submit(function(e) {
        		e.preventDefault();
  				$(".modal-body .ReturnForm1 .alert").html('');
				$(".modal-body .ReturnForm1 .alert").hide();
  				$(".modal-body .ReturnForm1 .alert").removeClass('alert-success');
  				$(".modal-body .ReturnForm1 .alert").removeClass('alert-danger');
                var item =$(this);
                item.css("opacity",0.5);
  			    $.ajax({
  			           type: "POST",
  			           url: $(".modal-body .ReturnForm1").attr("action"),
  			           data: $(".modal-body .ReturnForm1").serialize(),
  			           success: function(data)
  			           {
  			               item.css("opacity",1);
  			               res = JSON && JSON.parse(data) || $.parseJSON(data);
  			               if (typeof res.err != 'undefined') {
                                  $(".modal-body .ReturnForm1 .alert").html(res.err);
                                  $(".modal-body .ReturnForm1 .alert").show();
                                  $(".modal-body .ReturnForm1 .alert").addClass('alert-danger');
                           }
                           if (typeof res.succ != 'undefined') {
                                  $(".modal-body .ReturnForm1 .alert").html('');
                                  $(".modal-body .ReturnForm1 .alert").hide();
                                  $(".modal-body .ReturnForm1 .alert").removeClass('alert-success');
                                  $(".modal-body .ReturnForm1 .alert").removeClass('alert-danger');
                                  $(".modal-body .ReturnForm1 #login-email-address").hide();
                                  $(".modal-body .ReturnForm1 #oid").hide();
                                  $(".modal-body .intro-text").html(res.intro);
                                  $(".modal-body .ReturnForm1 #login-email-address").after(res.succ);
                                  $(".modal-body .ReturnForm1").attr("action",res.action);
                                  $(".modal-body .ReturnForm1").unbind("submit");
                                  bindReturnProductsForm();
                           } 
  			           }
  			         });
  			
  			    return false;
  			});
        
    });
}

function bindReturnProductsForm(){
  jQuery(".modal-body .ReturnForm1").submit(function(e) {
	    e.preventDefault();
        var item =$(this);
        item.css("opacity",0.5);
        jQuery(".modal-body .ReturnForm1 .alert").html('');
        jQuery(".modal-body .ReturnForm1 .alert").hide();
        jQuery(".modal-body .ReturnForm1 .alert").removeClass('alert-success');
        jQuery(".modal-body .ReturnForm1 .alert").removeClass('alert-danger');
	    jQuery.ajax({
	           type: "POST",
	           url: jQuery(".modal-body .ReturnForm1").attr("action"),
	           data: jQuery(".modal-body .ReturnForm1").serialize(),
	           success: function(data)
	           {
	               item.css("opacity",1);
	               res = JSON && JSON.parse(data) || jQuery.parseJSON(data);
	               if (typeof res.err != 'undefined') {
	               		jQuery(".modal-body .ReturnForm1 .alert").html(res.err);
						jQuery(".modal-body .ReturnForm1 .alert").show();
						jQuery(".modal-body .ReturnForm1 .alert").addClass('alert-danger');
						jQuery(".modal-body .ReturnForm1 .alert").css('margin-top','15px');
    				}
                   if (typeof res.succ != 'undefined') {
                          jQuery(".modal-body .ReturnForm1 .alert").html('');
                          jQuery(".modal-body .ReturnForm1 .alert").hide();
                          jQuery(".modal-body .ReturnForm1 .alert").removeClass('alert-success');
                          jQuery(".modal-body .ReturnForm1 .alert").removeClass('alert-danger');
                          jQuery(".modal-body .ReturnForm1 #login-email-address").hide();
                          jQuery(".modal-body .ReturnForm1 #oid").hide();
                          jQuery(".modal-body .ReturnForm1 .return-products").hide();
                          jQuery(".modal-body .ReturnForm1 .button--primary").hide();
                          jQuery(".modal-body .intro-text").html(res.intro);
                          jQuery(".modal-body .ReturnForm1 #login-email-address").after(res.succ);
                          jQuery(".modal-body .ReturnForm1").attr("action",res.action);
                          jQuery(".modal-body .ReturnForm1").unbind("submit");
                   } 
	           }
	         });
	
	    return false;
	});
}
